import { GAME_IDS } from '../../constants';
import {
  ASYNC_RESOURCE_LOADED,
  GAME_SELECTED,
  GAME_CONTINUE,
  GAME_TIMELIMIT,
  INVALID_GAME_SELECTED
} from './types';

/**
 * Alert redux that a lazy loaded resource has complete
 */
export const asyncResourceLoaded = resource => ({
  type: ASYNC_RESOURCE_LOADED,
  resource
});

/**
 * The game that the user is viewing has changed
 */
export const gameChanged = gameId => {
  if (GAME_IDS.indexOf(gameId) === -1) {
    console.log('Invalid game ID');
    return { type: INVALID_GAME_SELECTED };
  }
  return {
    type: GAME_SELECTED,
    gameId
  };
};

export const setContinue = b =>{
  return {
    type: GAME_CONTINUE,
    isContinue: b
  };
}

export const setTimeLimit = i =>{
  return {
    type: GAME_TIMELIMIT,
    timeLimit: i
  };
}
